<div class="header layout-corral">
  <a [routerLink]="rootPage?.link" class="logo">
    <div src="" alt="site logo"></div>
  </a>  
</div>


<div class="footer layout-corral">
  <div class="block">
    <div class="contact">
      <div>
        <a href="tel:+79161643929">+7 (916) 164-39-29 </a>
      </div>
      <div>
        <a href="mailto:info@rrms.ru">info@rrms.ru</a>
      </div>
      <div class="icons">
        <a href="https://www.youtube.com/@user-xd9lx2et9i">
          <img class="youtube" src="assets/images/youtube_logo.svg" alt="">
        </a>
        <a href="https://t.me/ARM_RusRisk">
          <img class="telegram" src="assets/images/telegram_logo.svg" alt="">
        </a>
      </div>
    </div>
    <div class="menu">
      <div>
        <a href="" routerLink="/">Главная</a>
      </div>
      <div>
        <a href routerLink="ob-associacii/obshhaya-informaciya">Об Ассоциации</a>
      </div>
      <div>
        <a href routerLink="clenstvo">Членство</a>
      </div>
      <div>
        <a href routerLink="publikatsii/novosti">События</a>
      </div>
    </div>
    <div class="menu">
      <div>
        <a href routerLink="baza-znanii">База знаний</a>
      </div>
      <div>
        <a href routerLink="sertifikaciya">Сертификация</a>
      </div>
      <div>
        <a href routerLink="kontakty">Контакты</a>
      </div>
      <div *ngIf="!isLoggedIn">
        <a (click)="login()">Вход в личный кабинет</a>
      </div>
    </div>
  </div>
  <div class="line"></div>
  <div class="copyright">
    <div>
       Copyright © 2004 - 2025 Ассоциация риск-менеджмента «Русское Общество Управления Рисками» 
    </div>
    <div class="op-63">
      Работает на платформе НИР
    </div>
  </div>
</div>
